// extracted by mini-css-extract-plugin
module.exports = {"icon-download-container":"styles_icon-download-container__DQ5sv"};